
import {
getStorage,
setStorage,
getThemeByType,
encrypt,
isWeixin,
isWxMiniProgram,
setCookie,
getEnv,
queryFormat,
getFormData,
setNavigation,
addWhiteList,
inLoanApp,
BuildVersionDiff,
getAppInfo,
isTTWebView,
bankCardRegularCheck
} from "@/js/utils";
import {
SUCCESS_CODE
} from "@/service/httpCode";


import selfInput1 from "@/components/SelfInput1";
import sendVerCodeBtn from "@/components/SendVerCodeBtn";
import bankCardCompliance from "@/components/BankCardCompliance";
import sendVertificationCode from "@/components/SendVertificationCode";
import creditComplicance from "@/components/BindCard/CreditComplicance";
import autoBindCard from "@/components/Repay/AutoBindCard";
import confirmBindCard from "@/components/Repay/ConfirmBindCard";
import OcrMethodDialog from "@/components/LoanBindCard/OcrMethodDialog";
import ocrMixins from "@/mixins/ocr";

const noticeTipsIcon = require("@/assets/bindCard/notice-tips@2x.png");
const arrowIcon = require("@/assets/bindCard/arrow@2x.png");

export default {
name: "bindcard",
components: {

selfInput1,
sendVerCodeBtn,
bankCardCompliance,
sendVertificationCode,
creditComplicance,
autoBindCard,
confirmBindCard,
OcrMethodDialog
},
data() {
return {
isLoading: false,
themeType: "default",
realname: "",
banks: [],
bankcardnum: "",
currentBank: null, // 选中银行的bankID
bankcardtel: "",
bankcardvcode: "",
showVcode: false, // 验证码框是否显示
isDisabled: false, // 按钮是否可点击,防止连续提交
hasCard: false, // 是否已绑卡
canSendVcode: true,
showSelectBank: false,
isMobileChangeShow: false,
isChecked: false,
showWithholdTag: false,
isBankDisabled: false,
isTarsInWX: false,
selectedShow: true,
contentShow: true,
protocolSelected: false,
formData: {
action: "",
params: [],
},
isVertificationCodeShow: false,
complianceCw: false,
noticeTipsIcon,
arrowIcon,
showCreditComplianceDialog: false,
isShowOCR: false,
isCallOCRBtnDisabled: false,
drawCardShow: false,
queryDrawCardTime: 10,
cebankList: [],
canPollingResult: true, // 控制页面是否需要轮询结果
currentBankId: "",
listenerServiceDone: false,
quickTradeId: "",
quickQuerySeconds: 10,
showConfirmDialog: false,
isOcrMethodShow: false,
ocrTag: 0,
bindCardMethod: 0, // 绑卡方式，0；手动输入，1：OCR，2：本地识别，3：一键绑卡
smsTradeID: ""
};
},
mixins: [ocrMixins],
computed: {
bankInfo() {
return (
this.banks.find((item) => item.bankID === this.currentBank) || {}
);
},
originBankNum() {
return this.bankcardnum.replace(/\s/g, "");
},
originTel() {
return this.bankcardtel.replace(/\s/g, "");
},
isBankNameShow() {
return this.bankInfo.bankName && !this.showSelectBank;
},
isCMBSigning() {
const bizType = getEnv();
return bizType == "Loan" || bizType == "Koo";
},
bindType() {

return this.originBankNum.includes("*") && this.originTel.includes("*")
? "auto"
: "normal";
}
},
created() {
this.isTarsInWX =
location.origin.includes("paifenle.com") && isWeixin();

if (this.isTarsInWX && window.history && window.history.pushState) {
window.history.pushState(null, "", "#");
window.addEventListener("popstate", this.popstateFunc);
}

const {
system
} = getAppInfo();
this.isAndroid = system === "android";

if (inLoanApp()) {
const [version, firstVer, secondVer, thirdVer] =
window.PPDWebUI.os.buildVersion.match(/(\d+)\.(\d+)\.(\d+)/);

this.isAutoBindCardSupport =
parseInt(
firstVer +
secondVer.padStart(2, "0") +
thirdVer.padStart(2, "0")
) >= 90000;
this.isCmbInstalled = false;





}


this.showTheLoading(async () => {
const {
appId,
bizCode,
orderType
} = this.$store;
this.sendRecord("500", bizCode);
this.sendRecord("510", appId);
this.sendRecord("520", Date.now());
this.orderNo = this.$store.orderNo;
const {
data,
result
} = await this.$http.bindcardLoad(
this.$store.orderNo
);
const themeMap = {
0: "default",
1: "red",
2: "rosiness",
3: "black",
};
if (result === SUCCESS_CODE) {
const {
realName,
bankList,
themeType,
sourceTitle,
returnUrl,
bindType,
userBankVo,
changeMobile,
showWithholdTag,
bankNo,
bindX,
copyWritingTag,
protocolTag,
complianceCw,
ocrTag,
drawCardShow,
queryDrawCardTime,
cebankList,
quickQuerySeconds
} = data;
this.bankcardnum = bankNo || "";
this.isBankDisabled = !!bankNo;
this.showWithholdTag = showWithholdTag;
this.hasCard = bindType === 2;
this.realname = realName;
this.banks = bankList || [];
this.themeType = getThemeByType(themeType || "0");
this.hasHeader = sourceTitle;
this.returnUrl = returnUrl;
this.isMobileChangeShow = changeMobile;
this.contentShow =
copyWritingTag === null ? true : copyWritingTag;
this.selectedShow = protocolTag === null ? true : protocolTag;
this.drawCardShow = drawCardShow;
this.queryDrawCardTime = queryDrawCardTime;
this.quickQuerySeconds = quickQuerySeconds;
setStorage("session", "banks", this.banks);
setStorage("session", "changeMobileParams", {
userBank: userBankVo,
themeType: this.themeType,
returnUrl,
bindX,
sourceTitle,
});

this.complianceCw =
getEnv() == "Koo" &&
(complianceCw === 3 ||
(this.isAndroid ?
complianceCw === 2 :
complianceCw === 1));


this.ocrTag = ocrTag || 0;

this.isShowOCR =
inLoanApp() &&
BuildVersionDiff("9.21.0") && this.ocrTag != 0;







if (
this.isAutoBindCardSupport &&
cebankList &&
cebankList.length > 0
) {
cebankList.forEach((bankInfo) => {

this.cebankList.push(bankInfo);
});
}


const {
tradeId
} = this.$route.query;
if (tradeId) {
this.tradeID = tradeId;
this.getSignPageInit();



if (this.bankcardnum.length > 11) {
const {
data,
result
} = await this.$http.queryCardBin({
cardNum: encrypt(this.originBankNum),
orderNum: this.orderNo,
});
if (result === SUCCESS_CODE && data) {
this.sendRecord("530", this.bankcardnum);
this.currentBank = data.bankID;
this.showSelectBank = false;
this.$store.selectedBank = data.bankID;
} else {
this.currentBank = null;
this.showSelectBank = true;
this.$store.selectedBank = "";
}
} else {
this.currentBank = null;
this.showSelectBank = false;
this.$store.selectedBank = "";
}


this.signProcessing();
}

this.sensorsRecord("h5_element_imp", {
tgt_event_id: "h5_paycash_bindcard_pageview",
tgt_name: "h5-paycash-普通绑卡页-页面曝光",
url: location.href,
page: "普通绑卡页",
param4: this.complianceCw,
param5: this.isShowOCR,
param6: this.drawCardShow,
param7: this.cebankList.length > 0,
param8: this.ocrTag,
param9: this.showWithholdTag
});

this.$bus.$emit("update-title", {
hasHeader: sourceTitle,
title: this.hasCard ? "更换银行卡" : "绑定银行卡",
noClose: bindX === false,
});
}
}, "isLoading");
},
activated() {
this.currentBank = this.$store.selectedBank;
},
beforeDestroy() {
if (this.isTarsInWX && window.history && window.history.pushState) {
window.removeEventListener("popstate", this.popstateFunc);
}
},
methods: {
popstateFunc() {
window.history.go(-2);
},
goToSupportBank() {
this.sendRecord("570");
this.$router.push({
name: "banks"
});
},
showToast(msg) {
this.$vux.toast.show({
type: "text",
text: msg,
width: "50%",
});
},
validCurrentBank() {
if (!this.currentBank) {
this.showToast("请选择开户行");
return false;
}
return true;
},
validTel() {
if (!this.bankcardtel) {
this.showToast("手机号码不能为空");
return false;
}

const telReg = /^(13|14|15|16|17|18|19)(\d|\*){9}$/;
if (!telReg.test(this.originTel)) {
this.showToast("请输入正确的手机号码");
return false;
}

return true;
},
check() {
if (!this.bankcardnum) {
this.showToast("银行卡号不能为空");
return false;
}


const cardReg = /^([1-9]{1})((\d|\*){11,19})$/;
if (!cardReg.test(this.originBankNum)) {
this.showToast("请输入正确的银行卡号");
return false;
}

if (!this.validCurrentBank()) return false;
if (!this.validTel()) return false;
















if (!this.protocolSelected && this.selectedShow) {
this.showToast("请阅读并勾选协议");
return false;
}
return true;
},
next() {
this.sendRecord("580");
this.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_bindcard_next",
tgt_name: "h5-paycash-普通绑卡页-下一步",
url: location.href,
page: "普通绑卡页",
param4: this.bindType,
param5: this.bindCardMethod,
});

if (this.bindType === "auto") {
this.showConfirmDialog = true;
} else {
if (!this.check()) return;

this.isDisabled = true;

this.showTheLoading(async () => {
if (
this.isShowOCR &&
this.originBankNum == this.identifiedCardNum
) {

this.sensorsRecord("h5_element_imp", {
tgt_event_id: "h5_paycash_bindcard_bankcard_consistent",
tgt_name: "h5-paycash-普通绑卡页-银行卡号一致",
url: location.href,
page: "普通绑卡页",
});
}
await this.sendVertificationCode();
});
this.isDisabled = false;
}
},
async sendVertificationCode() {
this.sendRecord("550");
const {
data,
result
} = await this.$http.sendSms({
bankID: this.currentBank,
cardNum: encrypt(this.originBankNum),
mobile: encrypt(this.originTel),
orderNum: this.orderNo,
callbackUrl: this.getSignReturnUrl(),
openWithholdTag: this.isChecked,
});
if (result === SUCCESS_CODE) {
this.tradeID = data.tradeID;
const {
redirectUrl,
redirectToken,
signTag
} = data;


if (this.isCMBSigning) {
if (signTag) {

this.handleBindApply();
} else if (redirectUrl) {

this.formData.action = redirectUrl;
this.formData.params = getFormData(redirectToken);
this.$nextTick(() => {












this.$refs.submitBtn.click();
});
} else {

this.isVertificationCodeShow = true;
}
} else {
this.isVertificationCodeShow = true;
}
}
return result;
},
seleckBank() {
this.$router.push({
name: "banks",
query: {
isBankSelectPage: "1"
},
});
},
telBlur() {
if (this.bankcardtel && this.bankcardtel.length === 13) {
this.sendRecord("540");
}
},
async checkCardBin() {
if (this.bindType === "normal") {

if (this.bankcardnum.length > 11 && bankCardRegularCheck(this.bankcardnum)) {
this.sensorsTrack("h5_clk", {
tgt_event_id: "h5_paycash_syt_1001",
tgt_name: "h5-paycash-普通绑卡页-输入银行卡号",
})

const {
data,
result
} = await this.$http.queryCardBin({
cardNum: encrypt(this.originBankNum),
orderNum: this.orderNo,
});
if (result === SUCCESS_CODE && data) {
this.sendRecord("530", this.bankcardnum);
this.currentBank = data.bankID;
this.showSelectBank = false;
this.$store.selectedBank = data.bankID;
} else {
this.currentBank = null;
this.showSelectBank = true;
this.$store.selectedBank = "";
}
} else {
this.currentBank = null;
this.showSelectBank = false;
this.$store.selectedBank = "";
}
}
},
showInfo() {
this.$vux.toast.show({
type: "text",
text: "仅限绑定本人银行卡",
width: "50%",
});
},
prephone() {
const vm = this;
this.$vux.confirm.show({
title: "提示",
content: "请确保和银行端预留手机号码一致，否则修改预留手机号码将失败！是否继续？",
onConfirm() {
vm.$router.push({
path: "/prephone?source=bindcard",
});
},
});
},
handleSelected(value) {
this.protocolSelected = value;
},

handleBindApply() {

const {
orderType,
orderNo,
appId,
userId
} = this.$store;

this.sendRecord("1040", this.bankcardnum);
this.sendRecord("1041", this.currentBank);

this.sensorsTrack("h5_clk", {
tgt_event_id: "h5_paycash_bindcard_apply_success",
tgt_name: "h5-paycash-普通绑卡页-绑卡申请成功",
param4: this.bankcardnum,
param5: this.currentBank,
param6: this.bindCardMethod,
param7: this.isChecked,
})

if ([6, 9].includes(orderType)) {

this.$store.selectedBank = "";
Object.assign(this.$data, {
bankcardnum: "",
currentBank: null, // 选中银行的bankID
bankcardtel: "",
bankcardvcode: "",
showVcode: false, // 验证码框是否显示})
});
this.$router.push({
name: "repay",
query: {
orderNo,
appId,
userId,
orderType
},
});
} else if ([20].includes(orderType)) {
this.$router.replace({
name: "pay",
query: {
orderNo,
appId,
userId,
orderType
},
});
} else {
if (isWxMiniProgram() || isTTWebView()) {
setCookie("MP_TO_BANK", "1", {
expires: 30,
domain: ".ppdai.com",
});
uni && uni.navigateBack();
} else {
location.href = this.returnUrl;
}
}
},

signProcessing() {

this.querySignResult();
this.timer = setTimeout(() => {
this.clearTimer();
if (this.statusCode == 200) {
this.handleBindApply();
}
}, 10000);
this.queryTimer = setInterval(async () => {
this.querySignResult();
}, 3000);
},

async querySignResult() {

this.loadingTimer = setTimeout(() => {
this.$vux.loading.show();
clearTimeout(this.loadingTimer);
}, 0);
const {
data,
result
} = await this.$http.bindConfirm({
tradeID: this.tradeID,
openWithholdTag: this.isChecked,
orderNum: this.orderNo,
});

if (result === SUCCESS_CODE) {
const {
statusCode
} = data;
this.statusCode = statusCode;

if (statusCode === 200) {
this.clearTimer();
this.handleBindApply();
}
}
},

clearTimer() {
clearInterval(this.queryTimer);
clearTimeout(this.timer);
this.$vux.loading.hide();
},

vertificationCodeCallback(vcode) {
if (vcode && vcode.length == 6) {
this.showTheLoading(async () => {
this.bankcardvcode = vcode;
const params = {
orderNum: this.orderNo,
tradeID: this.tradeID,
verifyCode: this.bankcardvcode,
};
if (this.showWithholdTag) {
Object.assign(params, {
openWithholdTag: this.isChecked,
});
}
const {
result
} = await this.$http.bindcardApply(params);
if (result === SUCCESS_CODE) {
this.handleBindApply();
}
});
}
},

getSignReturnUrl() {
const {
orderNo
} = this.$store;

const params = {
ord: orderNo,


o: this.isChecked,
p: this.protocolSelected,
};

return (
location.origin + location.pathname + "?" + queryFormat(params)
);
},

getSignPageInit() {
const {


o,
p
} = this.$route.query;


this.isChecked = o;
this.protocolSelected = p;
},











































showComplianceContent() {
if (!this.complianceCw) return;
this.showCreditComplianceDialog = true;
this.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_bindcard_compliance",
tgt_name: "h5-paycash-普通绑卡页-展示合规文案",
url: location.href,
page: "普通绑卡页",
});
},
goToWithdrawCard() {
this.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_bindcard_withdrawCard",
tgt_name: "h5-paycash-普通绑卡页-提现卡绑定",
url: location.href,
page: "普通绑卡页",
param4: this.orderNo,
});
this.$router.push({
name: "withdrawCard/bind",
query: {
orderNo: this.orderNo,
realname: encodeURIComponent(this.realname),
contentShow: this.contentShow,
selectedShow: this.selectedShow,
returnUrl: encodeURIComponent(this.returnUrl),
themeType: this.themeType,
queryDrawCardTime: this.queryDrawCardTime
},
});
},
applyBindCard(quickBindParams) {

this.quickBindParams = quickBindParams;
this.canPollingResult = true;
this.currentBankId = quickBindParams.bankId;

this.handleSelected(true);


this.bindCardMethod = 3;


this.quickBindApply(this.quickBindParams);
},
async quickBindApply({ type, bankId }) {
this.$vux.loading.show();

this.isQuickBindTrigger = true;

try {
const data = await this.doRequest("cequickBind", {
orderNum: this.$store.orderNo,
bankId,
returnUrl: `https://m.ppdai.com/?page#1009`,
});
this.$vux.loading.hide();
const { quickTradeId, resultParam, method, submitUrl } = data;
if (!resultParam || !submitUrl) {
return this.$toast("跳转银行签约失败，请重新签约");
}

if (type === 1) {

this.bankcardnum = "";
this.bankcardtel = "";

this.quickTradeId = quickTradeId;
const { href } = this.$router.resolve({
path: `/BindCardMiddlePage`,
query: {
submitUrl: submitUrl,
resultParam: resultParam,
},
});
if (!this.listenerServiceDone) {
this.listenerServiceDone = true;
window.PPDWebUI.ListenerService.resumeListener(
async () => {
if (this.isQuickBindTrigger) {
this.sendRecord("1023");
await this.pollingResult();
}
}
);
}
window.PPDWebUI.CommonService.openUrl(
{
url: location.origin + href,
},
function () { },
function () { }
);
} else {

this.quickTradeId = quickTradeId;

window.PPDWebUI.ListenerService.resumeListener(() => {

if (this.isQuickBindTrigger && this.canPollingResult) {
this.sendRecord("1023");
this.pollingResult();
}
});
this.bankcardnum = "";
this.bankcardtel = "";
const bankUrl = `cmbmobilebank://cmbls/functionjump?action=gofuncid&funcid=0026014&requesttype=post&cmb_app_trans_parms_start=here&epccGwMsg=${resultParam}`;
window.PPDWebUI.AppLinkService.launchApp(
{
data: bankUrl,
},
() => { },
(e) => {
this.$vux.toast.show({
type: "text",
text: "跳转招行失败了",
width: "50%",
});
}
);
}
} catch (e) {
this.$vux.loading.hide();
}
},
async pollingResult() {
this.$vux.loading.show();
this.isQuickBindTrigger = false;
const data = await this.quickBindProcessing();

if (this.statusCode === 1) {
this.$toast("快捷绑卡成功");

this.sensorsTrack("h5_clk", {
tgt_event_id: "h5_paycash_second_sign",
tgt_name: "h5-paycash-普通绑卡页-是否二次签约",
param4: data.secSign,
})

if (data.secSign === 1) {
this.$vux.loading.show();


const { phone, cardNum, bankId, quickTradeId } = data;
this.bankcardnum = cardNum;
this.currentBank = bankId;
this.$store.selectedBank = bankId;
this.isShowCurrentBank = true;
this.quickTradeId = quickTradeId;
this.bankcardtel = phone;

try {
const smsResult = await this.doRequest('cesendSms', {
orderNum: this.orderNo,
quickTradeId: this.quickTradeId
});
this.$vux.loading.hide();

this.smsTradeID = smsResult.tradeID;
this.showConfirmDialog = true;

this.sensorsTrack("h5_clk", {
tgt_event_id: "h5_paycash_send_sms_success",
tgt_name: "h5-paycash-普通绑卡页-发送短验成功",
param4: this.smsTradeID,
})
} catch (e) {
this.$vux.loading.hide();
this.sensorsTrack("h5_clk", {
tgt_event_id: "h5_paycash_send_sms_error",
tgt_name: "h5-paycash-普通绑卡页-发送短验异常",
param4: JSON.stringify(e),
param5: this.returnUrl,
})

location.href = this.returnUrl;
}
} else {
this.sensorsTrack("h5_clk", {
tgt_event_id: "h5_paycash_no_need_sign",
tgt_name: "h5-paycash-普通绑卡页-无需二次签约",
param4: this.returnUrl,
})

location.href = this.returnUrl;
}
}
this.$vux.loading.hide();

if (this.statusCode !== 1) {
this.$toast(data.resultMsg);
}
},
quickBindProcessing() {
return new Promise((resolve) => {
const seconds = this.quickQuerySeconds
? this.quickQuerySeconds * 1000
: 10000;
this.queryBindResult(resolve);
this.timer = setTimeout(() => {
this.clearTimer();
this.isQuickBindTrigger = true;

if (this.statusCode !== 1) {
resolve();
}
}, seconds);
this.queryTimer = setInterval(async () => {
this.queryBindResult(resolve);
}, 1000);
});
},
async queryBindResult(resolve) {
const data = await this.doRequest("cequeryQuickBindResult", {
quickTradeId: this.quickTradeId,
});
this.statusCode = data.statusCode;
if (data.statusCode != 0) {
this.clearTimer();
resolve(data);
}
},
closeConfirmDialog() {
this.showConfirmDialog = false;
},
sensorsTrack(eventType, params) {
this.sensorsRecord(eventType, Object.assign({
url: location.href,
page: "普通绑卡页",
}, params));
}
},
watch: {
bankcardtel(val) {
if (!this.showVcode && val.length === 13) {
if (!this.validCurrentBank()) return;




}
},
currentBank() {
if (!this.showVcode && this.bankcardtel !== "") {
if (!this.validTel()) return;




}
},

bankcardvcode(val) {
if (val.length === 6) {
this.isDisabled = false;
this.sendRecord("560");
}
},
},

mounted() {
addWhiteList();
},
};
